// extracted by mini-css-extract-plugin
export default {"title":"_3LtwX","rowTitle":"_2N7wO","icons":"_2ReFP","icon":"_1MAWg","row":"_3iXCE"};